module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAAC5JREFUOBFjXLJkyX+GAQBMA2An2MpRi+kW8qNBPRrUNAuB0cRFs6BFN3jkBTUAGvQDCcqlF08AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/warm up.png
// module id = AGs6
// module chunks = 38